export var GLOBAL={

    //url:'http://api-helpinghome.com/api/'
    url:'https://www.helpinghome.com.co/apihelpinghome/public/api/'
    

};
